import React, { useEffect, useState } from 'react';
import { apiFetch } from '../utils/serverConfig';

export default function AdminQuickMenu({ isAdmin }) {
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState({ students: 0, products: 0, orders: 0, attendance: 0 });
  const [, setError] = useState(null);
  const [health, setHealth] = useState({ status: 'unknown', ts: null });

  const load = async () => {
    setLoading(true); setError(null);
    try {
      // prefer consolidated /api/data endpoint
      const res = await apiFetch('/api/data');
      if (res && res.ok) {
        const payload = await res.json();
        setStats({
          students: Array.isArray(payload.students) ? payload.students.length : (payload.studentsCount || 0),
          products: Array.isArray(payload.products) ? payload.products.length : (payload.productsCount || 0),
          orders: Array.isArray(payload.orders) ? payload.orders.length : (payload.ordersCount || 0),
          attendance: Array.isArray(payload.attendance) ? payload.attendance.length : (payload.attendanceCount || 0),
        });
      } else {
        // fallback to /api/health or localStorage
        const h = await apiFetch('/api/health');
        if (h && h.ok) {
          const j = await h.json();
          setStats({ students: j.studentsCount || 0, products: j.productsCount || 0, orders: j.ordersCount || 0, attendance: j.attendanceCount || 0 });
        } else {
          const s = JSON.parse(localStorage.getItem('students') || '[]');
          const p = JSON.parse(localStorage.getItem('products') || '[]');
          const o = JSON.parse(localStorage.getItem('orders') || '[]');
          const a = JSON.parse(localStorage.getItem('attendance') || '[]');
          setStats({ students: s.length||0, products: p.length||0, orders: o.length||0, attendance: a.length||0 });
        }
      }
    } catch (err) {
      setError(String(err));
      try {
        const s = JSON.parse(localStorage.getItem('students') || '[]');
        const p = JSON.parse(localStorage.getItem('products') || '[]');
        const o = JSON.parse(localStorage.getItem('orders') || '[]');
        const a = JSON.parse(localStorage.getItem('attendance') || '[]');
        setStats({ students: s.length||0, products: p.length||0, orders: o.length||0, attendance: a.length||0 });
      } catch (e) { /* ignore */ }
    } finally {
      setLoading(false);
    }
  };

  const loadHealth = async () => {
    try {
      const res = await apiFetch('/api/health');
      if (res && res.ok) {
        const j = await res.json().catch(() => null);
        setHealth({ status: j && j.status ? j.status : 'ok', ts: j && j.timestamp ? j.timestamp : Date.now() });
      } else {
        setHealth({ status: 'down', ts: Date.now() });
      }
    } catch (e) {
      setHealth({ status: 'down', ts: Date.now() });
    }
  };

  useEffect(() => { if (isAdmin) load(); }, [isAdmin]);
  useEffect(() => {
    if (!isAdmin) return;
    loadHealth();
    const iv = setInterval(loadHealth, 30000);
    return () => clearInterval(iv);
  }, [isAdmin]);

  const openControlCenter = () => window.dispatchEvent(new CustomEvent('navigateTo', { detail: { view: 'controlcenter' } }));
  const openStudentPortal = () => window.dispatchEvent(new CustomEvent('navigateTo', { detail: { view: 'studentportal' } }));

  if (!isAdmin) return null;

  return (
    <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
      <div style={{ fontSize: 12, color: '#cbd5e1', display: 'flex', gap: 8, alignItems: 'center' }}>
        <div title={`Server health: ${health.status || 'unknown'}`} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div style={{ width: 10, height: 10, borderRadius: 99, background: health.status === 'ok' ? '#34d399' : (health.status === 'warn' ? '#f59e0b' : '#f87171'), boxShadow: '0 6px 18px rgba(2,6,23,0.6)' }} />
          <div style={{ fontSize: 11, opacity: 0.85 }}>{health.status === 'ok' ? 'Server OK' : (health.status === 'warn' ? 'Server OK (warn)' : 'Server down')}</div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: 11, opacity: 0.8 }}>Students</div>
          <div style={{ fontWeight: 700 }}>{loading ? '...' : stats.students}</div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: 11, opacity: 0.8 }}>Orders</div>
          <div style={{ fontWeight: 700 }}>{stats.orders}</div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: 11, opacity: 0.8 }}>Products</div>
          <div style={{ fontWeight: 700 }}>{stats.products}</div>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 6 }}>
        <button className="btn" onClick={load} title="Refresh quick stats">⟳</button>
        <button className="btn" onClick={openControlCenter} title="Open Control Center">⚙️</button>
        <button className="btn" onClick={openStudentPortal} title="Open Student Portal">👤</button>
      </div>
    </div>
  );
}
